import { exchangeColor } from '../../constant/color';

export interface Props {
  upbit?: boolean
  cobit?: boolean
  bithumb?: boolean
  value: string
  bold?: boolean
}

const Title = (props: any) => {
  let color = exchangeColor.upbit;
  
  if (props?.upbit) color = exchangeColor.upbit;
  else if (props?.cobit) color = exchangeColor.cobit;
  else if (props?.bithumb) color = exchangeColor.bithumb;
  else color = exchangeColor.default;

  let style: React.CSSProperties = {
    fontSize: 16,
    color,
    textAlign: 'center',
    fontWeight: props?.bold ? 900 : 400
  }

  return (
    <h1 style={style}>{props.value}</h1>
  );
};

export default Title;
